import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

type Props = {
  startedAt: string | null;
};

export const CfiRunningState = ({ startedAt }: Props) => {
  const startedTime = startedAt ? new Date(startedAt).getTime() : null;
  // Drive elapsed time off a state-backed `now` so render stays pure (calling
  // Date.now() directly during render trips the react-hooks/purity rule).
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    if (startedTime === null) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [startedTime]);

  const elapsedSeconds =
    startedTime !== null ? Math.max(0, Math.floor((now - startedTime) / 1000)) : null;

  return (
    <Box
      sx={{
        py: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1">Scoring the contract…</Typography>
      <Typography variant="caption" color="text.secondary">
        {elapsedSeconds !== null
          ? `${elapsedSeconds}s elapsed — typically completes in 2–4 minutes.`
          : 'Typically completes in 2–4 minutes.'}
      </Typography>
    </Box>
  );
};
